import React, { Component } from 'react';
import {secretPhraseToPublicKey,signTransactionBytes} from 'ardorjs';
import Grid from '@material-ui/core/Grid';
import {validatePrice, validatePassPhrase, validateQuantity} from '../common/validators';
import axios from 'axios';
import qs from 'qs';

import TextField from '@material-ui/core/TextField';
import {getAccountAssets, getAskOrders, getBidOrders, getIgnisBalance } from '../common/ardorinterface';
import {SignActionField} from '../common/signactionfield';
import { Typography } from '@material-ui/core';

import { NQTDIVIDER, REFERRALASSET } from '../common/constants';
import { TxSuccess } from '../common/txsuccess';
import { RefBalance } from '../referrals/tradereferrals';

/*
const ColoredLine = ({ color }) => (
  <hr
      style={{
          color: color,
          backgroundColor: color,
          height: 1,
          width: '80%'
      }}
  />
);
*/

class PlaceAskOrderForm extends Component {
  constructor (props){
    super(props);
    this.state = {
      bought:false,
      priceNQTPerShare:1.00,
      priceNQTPerShareStatus:{invalid:undefined,error:''},

      passPhrase:"",
      passPhraseStatus:{invalid:undefined,error:''},

      tradeQuantityQNT:1,
      tradeQuantityQNTStatus:{invalid:false,error:''},

      maxPrice:undefined,
      formValid:false,

    };
    this.placeOrder = this.placeOrder.bind(this);
    this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
  }

  placeOrder(event){
    const ORDERTYPE = "placeAskOrder";
    var self = this;
    console.log(self.state);
    let phraseValidated = validatePassPhrase(self.state.passPhrase,self.state.passPhraseStatus,self.props.user.accountRs);
    if  (phraseValidated.invalid){
      console.log("placeOrder(): passphrase invalid, exiting.")
      self.setState({passPhraseStatus:phraseValidated},this.validateForm);
      return;
    }
    console.log("placeOrder(): passphrase ok.")
    console.log('postOrder(): type:'+ORDERTYPE);
    const publicKey = secretPhraseToPublicKey(self.state.passPhrase);
    const passPhrase = self.state.passPhrase;
    const priceNQT = Math.floor(self.state.priceNQTPerShare*NQTDIVIDER);

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    var query = {
      requestType:ORDERTYPE,
      asset:REFERRALASSET,
      priceNQTPerShare:priceNQT,
      publicKey:publicKey,
      chain:2,
      quantityQNT:self.state.tradeQuantityQNT,
      feeNQT:-1,
      feeRateNQTPerFXT: -1,
      deadline:15,
      broadcast:false,
    }
    console.log(query,self.state.priceNQTPerShare);
    console.log('get minimumFee');
    const url_postOrder = self.props.nodeurl+'?requestType='+ORDERTYPE;
    const url_broadcast = self.props.nodeurl+'?requestType=broadcastTransaction';
    axios.post(url_postOrder, qs.stringify(query), config)
          .then(function(response) {
            //query.feeNQT = JSON.parse(data).minimumFeeFQT;response.data.minimumFeeFQT *response.data.bundlerRateNQTPerFXT*0.00000001;

            query.feeNQT = response.data.minimumFeeFQT*response.data.bundlerRateNQTPerFXT*0.00000001;
            query.broadcast = false;
            console.log('get transactionBytes');
            axios.post(url_postOrder, qs.stringify(query), config)
              .then(function(response){
                const signed = signTransactionBytes(response.data.unsignedTransactionBytes, passPhrase);
                let txdata = {transactionBytes:signed};
                console.log("sending signed transaction");
                axios.post(url_broadcast, qs.stringify(txdata), config)
                    .then(function(response){
                      console.log(response);
                      self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
                    })
              })
          })
          .catch(function (error) {
            console.log('ohje refresh state:');
            console.log(error.message);
            self.setState({status:"ERROR"})
          });
  }


  validateForm() {
    //console.log(this.state);
    this.setState({formValid: (this.state.tradeQuantityQNTStatus.invalid===false) && (this.state.passPhraseStatus.invalid===false) && (this.state.priceNQTPerShareStatus.invalid===false)});
  }

  
  handlePriceChange(event){
    //const valueNQT = Math.floor(event.target.value*NQTDIVIDER);
    //const value = valueNQT/NQTDIVIDER;
    const value = event.target.value;
    //const max=this.props.orderType==="placeBidOrder" ? this.state.maxPrice : undefined;
    const max = undefined;
    const min = 0;
    this.setState(
      {priceNQTPerShare:value},
      ()=> {const fieldStatus = validatePrice(value,max,min,this.state.priceNQTPerShareStatus);
            this.setState({priceNQTPerShareStatus:fieldStatus},this.validateForm);}
    );
  }


  handlePassphraseChange(value){
    this.setState(
      {passPhrase:value},
      ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus},this.validateForm);}
    );
  }


  handleQuantityChange(event){
    let value = event.target.value;
    const max = Math.min(this.props.refs.quantityQNT,this.props.refs.unconfirmedQuantityQNT);
    let min=1;
    this.setState(
      {tradeQuantityQNT:value},
      ()=>{let fieldStatus = validateQuantity(value,max,min,this.state.tradeQuantityQNTStatus);
            this.setState({tradeQuantityQNTStatus:fieldStatus},this.validateForm);}
    );
  }


  componentDidUpdate(){
    let newMax = (this.props.wallet.balanceNQT/this.props.NQTdivider)/this.state.tradeQuantityQNT;
    if (isNaN(newMax) === false & newMax !== this.state.maxPrice) {
      this.setState({maxPrice:newMax});
    }
  }


  render(){
    //console.log(this.state);
    //console.log(this.props);
    const max = Math.min(this.props.refs.quantityQNT,this.props.refs.unconfirmedQuantityQNT);
    if (!this.state.bought){
      if (this.props.refs.quantityQNT<1){
        return(
          <Typography variant="body1">
            No tokens, unable to create an ask order.
          </Typography>
        )
      }
      return (
        <form onSubmit={(event)=>{event.preventDefault();this.placeOrder()}}>
          <Grid container spacing={24} 
                  justify="center"
                  alignItems="center"
                  direction="column">
            <Grid item>
                <TextField invalid={this.state.tradeQuantityQNTStatus.invalid} 
                    type="number" 
                    name="tradeQuantityQNT"
                    label={"Amount of Tokens (max: "+max+")"}
                    error={this.state.tradeQuantityQNTStatus.invalid}
                    helperText={this.state.tradeQuantityQNTStatus.error}
                    variant="outlined"
                    InputLabelProps={{
                      type:"number",
                      shrink: true
                    }}
                    id="priceNQTPerShare" onChange={(event) => this.handleQuantityChange(event)}
                    value={this.state.tradeQuantityQNT}
                    placeholder="Enter price" />
              </Grid>
              <Grid item>
                <TextField invalid={this.state.priceNQTPerShareStatus.invalid} 
                    type="number" 
                    name="priceNQTPerShare"
                    label={"Price per Token"}
                    variant="outlined"
                    InputLabelProps={{
                      type:"number",
                      shrink: true
                    }}
                    id="priceNQTPerShare" onChange={(event) => this.handlePriceChange(event)}
                    value={this.state.priceNQTPerShare}
                    error={this.state.priceNQTPerShareStatus.invalid} 
                    helperText={this.state.priceNQTPerShareStatus.error}
                    placeholder="Enter price (IGNIS)" />
              </Grid>
              <Grid item>
                <SignActionField  {...this.props} {...this.state} gameaction="traderef" 
                    handlePassphraseChange={this.handlePassphraseChange}
                    action={this.placeOrder}/>
              </Grid>
          </Grid>
        </form>
      )
    }
    else {
       return (<TxSuccess response={this.state.response}/>)
    }
  }
}


export class PlaceRefAskOrder extends Component {
  constructor (props){
    super(props);
    this.state={
      refs:{unconfirmedQuantityQNT:0,quantityQNT:0,asset:REFERRALASSET},
      askOrders:[],
      bidOrders:[],
      wallet: {unconfirmedBalanceNQT:0, balanceNQT:0},
      response:{errorCode:undefined,error:""}
    }
    this.refresh = this.refresh.bind(this);
  }


  refresh(){
    console.log("cardAskOrder refresh()");
    var self = this;

    //console.log(this.props);
    getAccountAssets(this.props.nodeurl,this.props.user.accountRs,REFERRALASSET)
    .then((response)=>{
      //console.log(response);
      self.setState({refs:response});
      getAskOrders(this.props.nodeurl,response.asset)
      .then((response) => {
        self.setState({askOrders:response.askOrders});
      });
      getBidOrders(this.props.nodeurl,response.asset)
      .then((response) => {
        //console.log(response);
        self.setState({bidOrders:response.bidOrders});
      });
    })
    .catch((err)=>{console.log(err)});

    getIgnisBalance(self.props.nodeurl,self.props.user.accountRs)
    .then(function(response){
        self.setState({wallet:response})
    });
  }

  componentDidMount(){
    this.refresh();
    this.timer = setInterval(this.refresh,9000);
  }

  componentWillUnmount(){
    clearInterval(this.timer);
  }


  render() {
    return (
      <div style={{textAlign:"center", padding:10, width:"90%", display:"inline-block"}}>
      <Grid container spacing={8}
          className="boxed"
          justify="center"
          alignItems="flex-start"
          direction="row"
          style={{ marginTop: 5, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)", backgroundColor: '#1D1D1D',}}>
            
          <Grid item>

            <Grid container spacing={12}
                  justify="center"
                  alignItems="center"
                  direction="column"
                  
              >
                <Grid item>
                  <RefBalance refs={this.state.refs}/>
                </Grid>
                <Grid item >
                  <Typography variant="h4"> Sell order REFs </Typography>
                  <Typography> &nbsp;</Typography>
                  <PlaceAskOrderForm {...this.state} {...this.props} />                  
                </Grid>
            </Grid>
          </Grid>
        </Grid>
    </div>
    );
  }
}

